module.exports = __webpack_public_path__ + "static/media/banner_el_GR.3ab5faa6.png";